module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate8.c566818.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate8.png
// module id = 767
// module chunks = 0